import 'css-chunksrc/client/pages/projectPage/timeSheetPage/loader/styles.scss';export default {
  "allocations": "_allocations_155mi_1",
  "even": "_even_155mi_5"
};